module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_04@2x-31abe746ad2b8d4f0c78b5701cb2f46a.jpg";